import React, { useRef, useMemo, useState, useEffect } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { DATA_SOURCE_NAME_MAP } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
// import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import useActiveUserBarCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useActiveUserBarCharts';
import useActiveUserLineCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useActiveUserLineCharts';
import useActiveUserPieCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useActiveUserPieCharts';
import { getLocale } from 'umi';

import type { IChartsIndexInstance } from '@intelligence/components/ChartsComponents/ChartsIndex';

const getFullMetrics = (params?: {
  dataSources?: string[] | null;
  metrics?: string[] | null;
  currentMetrics?: any[];
}) => {
  const fullMetrics = [];
  const { dataSources, metrics, currentMetrics } = params || {};
  if (!Array.isArray(dataSources) || !dataSources.length) return [];
  if (!Array.isArray(metrics) || !metrics.length) return [];

  for (const dataSource of dataSources) {
    for (const metric of metrics) {
      const currentMetric = currentMetrics?.find((item) => {
        const { source: itemDataSource, metric: itemMetric } = item || {};
        return dataSource === itemDataSource && metric === itemMetric;
      });
      const currentMetricTmp = currentMetric || {
        b_predict: false,
        dod: null,
        growth_ratio: null,
        source: dataSource,
        metric,
        name: '',
        value: null,
      };
      fullMetrics.push(currentMetricTmp);
    }
  }

  return fullMetrics;
};

//每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    primaryKey,
    dataSources,
    fetchParams,
    barOrPieData,
    lineData,
    sourceOrders,
    echartsData,
    dateType,
    isVisualisLoading,
    chartType = 'bar',
    isDataBrain,
    titleNow = '',
    topChartsType = '',
    isNodata,
    imageType,
    sortByName,
    sortByNameCn,
    gameHighId = '',
    isStudio = false,
  } = props;

  // console.log('ActiveUserVisualis', props);
  const locale = getLocale(); // 中英切换方法

  const chartsInstance = useRef<IChartsIndexInstance>(null);

  const titleNowValue = useMemo(() => {
    if (sortByName && sortByNameCn) {
      return locale === 'zh-CN' ? sortByNameCn : sortByName;
    } else {
      return titleNow
    }
  }, [sortByName, titleNow, sortByNameCn, locale]);

  const dataSourceNames = useMemo(() => {
    if (!Array.isArray(dataSources)) return [];
    return dataSources.map(item => DATA_SOURCE_NAME_MAP[item])
      .filter(item => item);
  }, [dataSources]);

  //根据排序获得Sorted by 标题
  // const orderNameInfo = useMemo(() => {
  //   if (!fetchParams) return '';
  //   const {
  //     order_source: orderSource,
  //     order_metric: orderMetric,
  //     ratio_type: ratioType,
  //   } = fetchParams;

  //   // console.log('fetchParams', fetchParams);

  //   const orderSourceName = DATA_SOURCE_NAME_MAP[orderSource] || '';
  //   let result = `${(topChartsType === 'activeuser' || topChartsType === 'databrain') ? orderSourceName : ''} ${titleNowValue}`;
  //   return (ratioType === SortMode.Circle || topChartsType == 'revenue') ? `${result}(%)` : result;
  // }, [fetchParams?.order_source, fetchParams?.order_metric, fetchParams?.ratio_type, fetchParams?.date_type, titleNow]);

  const [chartsData, setChartsData] = useState<any>({
    metricChartlist: [],
    timelineOfMetricChartlist: [],
  });

  // 补全缺失的指标对象，目前改方法只补全缺失的dau指标对象
  const getFullDauMetrics = (metrics: any[]): any[] => {
    if (!Array.isArray(metrics)) return [];
    const dauMetricsSources = metrics.map(item => item.source);
    const lostDauMetricsSources = (dataSources || []).filter((item: string) => !dauMetricsSources.includes(item));
    if (!lostDauMetricsSources.length) return metrics;
    const fullDauMetrics = [...metrics];
    for (let i = 0; i < lostDauMetricsSources.length; i++) {
      const lostDauMetricSource = lostDauMetricsSources[i];
      const lostDauMetric = {
        source: lostDauMetricSource,
        value: '',
        growth_ratio: '',
        b_predict: false,
        metric: 'dau',
        order_metric: `${lostDauMetricSource}_dau`,
        order_source: lostDauMetricSource,
        titleNow,
      };
      fullDauMetrics.push(lostDauMetric);
    }
    return fullDauMetrics;
  };

  const getSortedMetrics = (metrics: any[]): any[] => {
    if (!Array.isArray(metrics)) return [];
    return metrics.sort((a: any, b: any): number => {
      const aIndex = sourceOrders.indexOf(a.source);
      const bIndex = sourceOrders.indexOf(b.source);
      return aIndex - bIndex;
    });
  };

  const getBarOrPieDataOfComponent = (games: any[]) => {
    const result: any[] = [];
    if (!Array.isArray(games)) return [];

    for (let i = 0; i < games.length; i++) {
      const game = games[i];
      let newGame = null;
      let metricValueList = [];
      let newMetricValueList = [];
      if (!game || !game[primaryKey]) continue;
      metricValueList = Array.isArray(game.metric_list) ? game.metric_list : [];
      //按数据源与指标名称重新排序，再下传
      // const metricValueListTemp = sortByTargetMetricList(fetchParams?.metrics || [], fetchParams?.data_sources || [], metricValueList);
      for (let j = 0; j < metricValueList.length; j++) {
        const metricValue = metricValueList[j];
        if (!metricValue || !metricValue.source || !metricValue.metric || metricValue.metric !== 'dau') continue;
        const newMetricValue = {
          ...metricValue,
          b_predict: false,
          metric: metricValue.source,
          order_metric: `${metricValue.source}_${metricValue.metric}`,
          order_source: metricValue.source,
          titleNow,
        };
        newMetricValueList.push(newMetricValue);
      }
      newGame = {
        ...game,
        id: game[primaryKey],
        imageUrl: game.cover,
        name: game.name,
        rank_metric: game.name,
        metric_value_list: getSortedMetrics(getFullDauMetrics(newMetricValueList)),
        metric_list: getFullMetrics({ dataSources: fetchParams?.data_sources, metrics: fetchParams?.metrics?.slice(0, 1), currentMetrics: metricValueList }),
      };
      result.push(newGame);
    }

    // console.log('result', result);

    return result;
  };

  const getLineDataOfComponent = (games: any): any[] => {
    const result: any[] = [];
    if (Array.isArray(games)) {
      for (let i = 0; i < games?.length; i++) {
        const game = games[i];
        if (!game) continue;
        const timeLines = game.metric_value_list;
        if (!Array.isArray(timeLines)) continue;
        for (let j = 0; j < timeLines.length; j++) {
          const timeLine = timeLines[j];
          if (!timeLine) continue;
          const time = timeLine.time;
          let metricValueList = timeLine.metric_value_list;
          metricValueList = Array.isArray(metricValueList) ? metricValueList : [];
          metricValueList = getSortedMetrics(getFullDauMetrics(metricValueList));

          // console.log('metricValueList11111111111111111111111', metricValueList);

          if (!time || !Array.isArray(metricValueList)) continue;
          const newMetricValueList: any = [];
          for (let k = 0; k < metricValueList.length; k++) {
            const metric = metricValueList[k];

            // if (!metric || metric.metric !== 'dau') continue;
            if (!metric) continue;

            newMetricValueList.push({
              ...metric,
              b_predict: metric.b_predict,
              metric: metric.source,
              order_source: metric.source,
              order_metric: `${metric.source}_${metric.metric}`,
              titleNow,
            });
          }
          result.push({
            ...game,
            time,
            rank_name: game.name,
            metric_value_list: newMetricValueList,
          });
        }
      }
    }
    // console.log('result11111111111111111111111', result);
    return result;
  };

  useEffect(() => {
    const barOrPieDataOfComponent = getBarOrPieDataOfComponent(barOrPieData);
    const lineDataOfComponent = getLineDataOfComponent(lineData);
    setChartsData({ ...chartsData, metricChartlist: barOrPieDataOfComponent, timelineOfMetricChartlist: lineDataOfComponent });
  }, [barOrPieData, lineData, titleNow]);


  const lenten = useMemo(() => {
    return chartsData.metricChartlist ?
      chartsData.metricChartlist.filter((item: any, index: any) => index < 10)
      : chartsData.metric_chart_list.filter((item: any, index: any) => index < 10);
  }, [chartsData]);

  //获取柱状图hooks
  const {
    barOption,
    showBarPeiName,
  } = useActiveUserBarCharts({
    sendEchartsData: chartsData,
    loading: isVisualisLoading,
    dataSourceEachers: dataSourceNames,
    isDataBrain,
    lenten,
    titleNow: titleNowValue,
    topChartsType,
    startDate: fetchParams.start_date,
    endDate: fetchParams.end_date,
    gameHighId,
    isStudio
  });

  // //获取折线图hooks
  // const {
  //   lineOption
  // } = useActiveUserLineCharts({
  //   sendEchartsData: chartsData,
  //   loading: isVisualisLoading,
  //   dataSourceEachers: dataSourceNames,
  //   titleNow: titleNowValue,
  //   topChartsType,
  //   imageType,
  //   chartType,
  //   dateType,
  //   startDate: fetchParams.start_date,
  //   endDate: fetchParams.end_date,
  //   chartsInstance,
  // });

  // //获取饼图hooks
  // const {
  //   pieOption
  // } = useActiveUserPieCharts({
  //   chartType,
  //   chartsInstance,
  //   sendEchartsData: chartsData,
  //   loading: isVisualisLoading,
  //   dataSourceEachers: dataSourceNames,
  //   lenten,
  //   titleNow: titleNowValue,
  //   startDate: fetchParams?.start_date,
  //   endDate: fetchParams?.end_date,
  // });

  const chartLoading = useMemo(() => {
    return barOption || isNodata ? false : true;
  }, [barOption, isNodata]);

    //获取折线图hooks
    const {
      lineOption
    } = useActiveUserLineCharts({
      sendEchartsData: chartsData,
      loading: isVisualisLoading || chartLoading,
      dataSourceEachers: dataSourceNames,
      titleNow: titleNowValue,
      topChartsType,
      imageType,
      chartType,
      dateType,
      startDate: fetchParams.start_date,
      endDate: fetchParams.end_date,
      chartsInstance,
      gameHighId,
      isStudio
    });

    //获取饼图hooks
    const {
      pieOption
    } = useActiveUserPieCharts({
      chartType,
      chartsInstance,
      sendEchartsData: chartsData,
      loading: isVisualisLoading,
      dataSourceEachers: dataSourceNames,
      lenten,
      titleNow: titleNowValue,
      startDate: fetchParams?.start_date,
      endDate: fetchParams?.end_date,
      gameHighId,
      isStudio
    });

  return (
    <>
      {/* <ArrowdownText isNew={true} sortedData={orderNameInfo} order={orderTypeInfo} /> */}
      <div className="card-line">
        <ChartsIndex
          ref={chartsInstance}
          echartsData={echartsData || {}}
          dataSourceEachers={dataSourceNames}
          chartLoading={chartLoading}
          barOption={barOption}
          lineOption={lineOption}
          pieOption={pieOption}
          chartType={chartType}
          showBarPeiName={showBarPeiName}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
